import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

export default React.memo(function CommentList({
  title,
  prefix,
  comments,
}: Readonly<{
  title: string;
  prefix: string;
  comments: any[];
}>) {
  const router = useRouter();
  const params = router.query as { id: string; slug: string };
  const currentDiscussionId = parseInt(
    params.id.split('-').pop() as string,
    10,
  );

  const nonCurrentComments = useMemo(
    () => comments.filter((comment) => comment.id !== currentDiscussionId),
    [comments, currentDiscussionId],
  );

  if (nonCurrentComments.length === 0) {
    return null;
  }

  return (
    <div className="my-4">
      <h5 className="font-header text-base font-bold">{title}</h5>
      <ul>
        {nonCurrentComments.map((comment) => (
          <li key={comment.id}>
            <a
              href={`${prefix}${comment.url_path_suffix}`}
              className="my-4 text-blue-600 line-clamp-2 hover:underline"
            >
              {comment.title || comment.comment}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
});
